import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';

// This is component is need tailwind 2.2 version to work

function PopUp({
  children,
  render,
  id,
  autoClose,
  positionClassName,
  containerClassName,
  sizeClassName,
  closePopUp,
  withClose,
}) {
  const [animate, setAnimate] = React.useState(false);
  const [isShow, setIfShow] = React.useState(false);

  const ref = React.useRef(null);

  const handleOnClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isShow) {
      setIfShow(true);
      setTimeout(() => {
        setAnimate(true);
      }, 200);
      return;
    }
    setAnimate(false);
    setTimeout(() => {
      setIfShow(false);
    }, 200);
  };

  React.useEffect(() => {
    let x;
    if (closePopUp) {
      setAnimate(false);
      setTimeout(() => {
        setIfShow(false);
      }, 200);
    }
    return () => {
      clearTimeout(x);
    };
  }, [closePopUp]);

  const handleClearToggle = React.useCallback(
    (e) => {
      try {
        if ((ref.current && !ref.current.contains(e.target)) || isShow) {
          setAnimate(false);
          setTimeout(() => {
            setIfShow(false);
          }, 200);
        }
      } catch (error) {
        // do nothing...
      }
    },
    [id, isShow]
  );

  React.useEffect(() => {
    if (autoClose && isShow) {
      document.addEventListener('mousedown', handleClearToggle, false);
    }
    return () => {
      document.removeEventListener('mousedown', handleClearToggle, false);
    };
  }, [autoClose, id, isShow]);

  React.useEffect(() => {
    const escFunction = (e) => {
      if (e.keyCode === 27) {
        setAnimate(false);
        setTimeout(() => {
          setIfShow(false);
        }, 200);
      }
    };

    if (isShow) {
      document.addEventListener('keydown', escFunction, false);
    }
    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, [autoClose, isShow]);

  return (
    <div
      ref={ref}
      className={cn(
        'relative inline-block text-left w-full',
        containerClassName
      )}
    >
      <div
        onClick={handleOnClick}
        role="presentation"
        className="cursor-pointer"
      >
        <span className="sr-only">Open options</span>
        {render}
      </div>
      {isShow && (
        <div
          id={id}
          className={`${positionClassName} ${sizeClassName} absolute rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 origin-top focus:outline-none transition ease-out duration-100 transform z-40 ${
            !animate ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
          }`}
        >
          {withClose && (
            <button
              type="button"
              aria-label="Close"
              onClick={handleOnClick}
              className="absolute right-0 top-0 p-2"
            >
              <svg
                className="w-4 h-4 text-gray-500 hover:text-gray-600"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          )}
          {children}
        </div>
      )}
    </div>
  );
}

PopUp.defaultProps = {
  children: {},
  id: 'option-menu',
  render: (
    <svg
      className="h-5 w-5"
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
    </svg>
  ),
  autoClose: false,
  containerClassName: '',
  positionClassName: 'right-0',
  sizeClassName: 'w-56',
  closePopUp: false,
  withClose: false,
};

PopUp.propTypes = {
  children: PropTypes.instanceOf(Object),
  render: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.instanceOf(Function),
  ]),
  id: PropTypes.string,
  containerClassName: PropTypes.string,
  autoClose: PropTypes.bool,
  positionClassName: PropTypes.string,
  sizeClassName: PropTypes.string,
  closePopUp: PropTypes.bool,
  withClose: PropTypes.bool,
};

export default PopUp;
